import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconArrowLeft = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M6.40997 11L9.70997 7.71004L8.28997 6.29004L2.58997 12L8.28997 17.71L9.70997 16.29L6.40997 13H20V11H6.40997Z" }))));
};
